var _excluded = ["as"],
  _excluded2 = ["as"],
  _excluded3 = ["as"],
  _excluded4 = ["as"],
  _excluded5 = ["as"],
  _excluded6 = ["as"],
  _excluded7 = ["as"],
  _excluded8 = ["as"],
  _excluded9 = ["as"],
  _excluded0 = ["as"],
  _excluded1 = ["as"],
  _excluded10 = ["as"],
  _excluded11 = ["as"],
  _excluded12 = ["as"],
  _excluded13 = ["as"],
  _excluded14 = ["as"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { applyFont, tokens } from '@domain-group/fe-brary';
import { css } from '@emotion/core';
import { jsx as ___EmotionJSX } from "@emotion/core";
var typography = tokens.typography;
var fontStyle = (fontDef, boldFont) => /*#__PURE__*/css(applyFont(fontDef), " ", boldFont && /*#__PURE__*/css("& strong{", applyFont(boldFont), "}"));
export var PageHeading = _ref => {
  var as = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = as || 'h1';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.pageheading)
  }, props));
};
export var Heading = _ref2 => {
  var as = _ref2.as,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var Component = as || 'h2';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.heading)
  }, props));
};
export var Subheading = _ref3 => {
  var as = _ref3.as,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var Component = as || 'h3';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.subheading)
  }, props));
};
export var Body = _ref4 => {
  var as = _ref4.as,
    props = _objectWithoutProperties(_ref4, _excluded4);
  var Component = as || 'p';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.body, typography.bodyBold)
  }, props));
};
export var BodyBold = _ref5 => {
  var as = _ref5.as,
    props = _objectWithoutProperties(_ref5, _excluded5);
  var Component = as || 'p';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.bodyBold)
  }, props));
};
export var Caption = _ref6 => {
  var as = _ref6.as,
    props = _objectWithoutProperties(_ref6, _excluded6);
  var Component = as || 'p';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.caption, typography.captionBold)
  }, props));
};
export var CaptionBold = _ref7 => {
  var as = _ref7.as,
    props = _objectWithoutProperties(_ref7, _excluded7);
  var Component = as || 'p';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.captionBold)
  }, props));
};
export var Mini = _ref8 => {
  var as = _ref8.as,
    props = _objectWithoutProperties(_ref8, _excluded8);
  var Component = as || 'p';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.mini, typography.miniBold)
  }, props));
};
export var MiniBold = _ref9 => {
  var as = _ref9.as,
    props = _objectWithoutProperties(_ref9, _excluded9);
  var Component = as || 'p';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.miniBold)
  }, props));
};
export var Lead = _ref0 => {
  var as = _ref0.as,
    props = _objectWithoutProperties(_ref0, _excluded0);
  var Component = as || 'p';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.lead)
  }, props));
};
export var Overline = _ref1 => {
  var as = _ref1.as,
    props = _objectWithoutProperties(_ref1, _excluded1);
  var Component = as || 'p';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.overline)
  }, props));
};
export var Callout = _ref10 => {
  var as = _ref10.as,
    props = _objectWithoutProperties(_ref10, _excluded10);
  var Component = as || 'p';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.callout)
  }, props));
};
export var Code = _ref11 => {
  var as = _ref11.as,
    props = _objectWithoutProperties(_ref11, _excluded11);
  var Component = as || 'p';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.code)
  }, props));
};
export var DisplayLarge = _ref12 => {
  var as = _ref12.as,
    props = _objectWithoutProperties(_ref12, _excluded12);
  var Component = as || 'h1';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.displayLarge)
  }, props));
};
export var DisplayMedium = _ref13 => {
  var as = _ref13.as,
    props = _objectWithoutProperties(_ref13, _excluded13);
  var Component = as || 'h2';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.displayMedium)
  }, props));
};
export var DisplaySmall = _ref14 => {
  var as = _ref14.as,
    props = _objectWithoutProperties(_ref14, _excluded14);
  var Component = as || 'h3';
  return ___EmotionJSX(Component, _extends({
    css: fontStyle(typography.displaySmall)
  }, props));
};